import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-gurukula-skills',
  templateUrl: './gurukula-skills.component.html',
  styleUrls: ['./gurukula-skills.component.scss']
})
export class GurukulaSkillsComponent {


  skillsForm: FormGroup;

  @Output() formSubmitted: EventEmitter<any> = new EventEmitter();

  constructor(private fb: FormBuilder) {
    this.skillsForm = this.fb.group({
      management: [null, Validators.required],
      salesMarketing: [null, Validators.required],
      fileManagement: [null, Validators.required],
      officeAdmin: [null, Validators.required],
      orgManagement: [null, Validators.required],
      reception: [null, Validators.required],
      humanResources: [null, Validators.required],
      projectCoordination: [null, Validators.required],


      architecture: [null, Validators.required],
      flowersGarlands: [null, Validators.required],
      artsCrafts: [null, Validators.required],
      music: [null, Validators.required],
      interiorDesign: [null, Validators.required],
      photography: [null, Validators.required],
      videoFilm: [null, Validators.required],
      sewing: [null, Validators.required],
      graphicDesign: [null, Validators.required],



      dataEntry: [null, Validators.required],
      installationRepair: [null, Validators.required],
      computerProgramming: [null, Validators.required],
      microsoftOffice: [null, Validators.required],
      webDevelopment: [null, Validators.required],
      erp: [null, Validators.required],
      networking: [null, Validators.required],
      microsoftAccess: [null, Validators.required],
      systemAdministration: [null, Validators.required],
      typing: [null, Validators.required],
      autocad: [null, Validators.required],




      airConditioning: [null, Validators.required],
      carpentry: [null, Validators.required],
      electrical: [null, Validators.required],
      civilEngineering: [null, Validators.required],
      mechanicalEngineering: [null, Validators.required],
      electricalEngineering: [null, Validators.required],
      structuralEngineering: [null, Validators.required],
      generalMaintenance: [null, Validators.required],
      heavyEquipment: [null, Validators.required],
      plumbing: [null, Validators.required],
      surveying: [null, Validators.required],
      welding: [null, Validators.required],




      legal: ['', Validators.required],
      bookkeeping: ['', Validators.required],
      budgeting: ['', Validators.required],
      accounting: ['', Validators.required],
      cashier: ['', Validators.required],
      purchasing: ['', Validators.required],
      otherFinance: ['', Validators.required],



      baking: [null, Validators.required],
      cooking: [null, Validators.required],
      restaurantManagement: [null, Validators.required],




      medicalCounseling: [null, Validators.required],
      dental: [null, Validators.required],
      doctor: [null, Validators.required],
      nursing: [null, Validators.required],
      pharmacist: [null, Validators.required],
      therapist: [null, Validators.required],
      hathaYogaInstructor: [null, Validators.required],




      audio: [null, Validators.required],
      video: [null, Validators.required],
      lighting: [null, Validators.required],
      drafting: [null, Validators.required],
      electronics: [null, Validators.required],
      mechanic: [null, Validators.required],
      telecommunications: [null, Validators.required],






      // LANGUAGE AND COMMUNICATION 1 2 3

      journalism: [null, Validators.required],
      hindiTyping: [null, Validators.required],
      shvetambariTyping: [null, Validators.required],
      otherLanguagesTyping: [null, Validators.required],
      proofreading: [null, Validators.required],
      publicSpeaking: [null, Validators.required],
      fluentTranslation: [null, Validators.required],
      noteTaking: [null, Validators.required],



      // OTHER SKILLS & SERVICES
      animalCare: [null, Validators.required],
      childCare: [null, Validators.required],
      cleaning: [null, Validators.required],
      educationTeaching: [null, Validators.required],
      gardening: [null, Validators.required],
      horticulture: [null, Validators.required],
      agriculture: [null, Validators.required],
      militarySecurity: [null, Validators.required], 

      // SIDDHA YOGA TRAINING
      meditationTeacher: [null, Validators.required],
      siddhaYogaFacilitator: [null, Validators.required],
      // hathaYogaInstructor: [null, Validators.required],
      // music: [null, Validators.required], // Add a field to specify if needed
      contentDevelopment: [null, Validators.required],
      eventPlanning: [null, Validators.required],
      other: [null], // Optional field




       // GENERAL ABILITIES
       activeListening: [null, Validators.required],
       creativeProblemSolving: [null, Validators.required],
       teamWorking: [null, Validators.required],
       reliability: [null, Validators.required],
       flexibilityToChange: [null, Validators.required],
       leadership: [null, Validators.required],
       proactivity: [null, Validators.required],
       criticalThinking: [null, Validators.required],
       communicatingClearly: [null, Validators.required],
       willingnessToLearn: [null, Validators.required],
       workingAlone: [null, Validators.required],
       interpersonalSkills: [null, Validators.required],
       patience: [null, Validators.required],
       detailOrientation: [null, Validators.required],
       givingFeedback: [null, Validators.required],
       receivingFeedback: [null, Validators.required],
       respectingConfidentiality: [null, Validators.required],
       calmnessInDifficultSituations: [null, Validators.required],
       sharingKnowledge: [null, Validators.required],
       creativeAbility: [null, Validators.required],
       numericalAbility: [null, Validators.required],
       physicalAbility: [null, Validators.required],


    });
  }

  ngOnInit(): void {
    // Any additional initialization logic can go here
  }

  onSubmit() {
    if (this.skillsForm.valid) {
      this.formSubmitted.emit(this.skillsForm.value);
  
    } else {

    }
  }

  goToBack() {
    // Logic to navigate back to the previous step
  }




}
